export default __webpack_public_path__ + "static/media/score-sys.c681a5f6.png";